import {useState} from 'react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import FormInput from '../common/FormInput';
import {useCreateReferrerCompanyMutation} from '../../redux/services/referrerCompanyApi';

const getFields = () => ([
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    validate: val => true,
    placeholder: 'Enter referrer name',
  },
]);

const parseFormValues = values => values;

const handleFieldUpdate = ({formValues, setFormValues}) => name => (e,  val) => {
  const value = val ? val : (e.target ? e.target.value : null);
  setFormValues({
    ...formValues,
    [name]: value,
  });
};

const handleSubmit = ({post, afterSubmit}) => async (e, formValues) => {
  const body = parseFormValues(formValues);
  const response = await post(body);
  if (response.error) {
    console.error('Error creating referrer:', response.error);
    return;
  }
  if (afterSubmit) afterSubmit(e, response.data.id);
};

const getDefaultFormValues = () => ({
  name: '',
});

const ReferrerCompanyForm = props => {
  const defaultValues = getDefaultFormValues();
  const [formValues, setFormValues] = useState(defaultValues);
  const [post, response] = useCreateReferrerCompanyMutation();
  const fields = getFields();
  const onFieldUpdate = handleFieldUpdate({formValues, setFormValues});
  const onSubmit = handleSubmit({post, formValues, afterSubmit: props.afterSubmit});
  return (
    <Stack gap={1}>
      {
        response.error && <Alert severity='error'>
          Error creating referrer: {response.error.message}
        </Alert>
      }
      {fields.map(f => 
          <FormInput
            {...f}
            defaultValue={defaultValues?.[f.name] || f.defaultValue}
            onChange={onFieldUpdate(f.name)}
          />
      )}
      <Button
        variant='primaryGradient'
        disabled={response.isLoading}
        onClick={e => onSubmit(e, formValues)}
      >
        Save
      </Button>
    </Stack>
  );
};

export default ReferrerCompanyForm;